module.exports = __webpack_public_path__ + "static/media/wechat-app.f21c9e12.png";